import { useUser } from "@/hooks/useUser";
import { isAdminRole, resolveUserRole } from "@/lib/userRole";

export function useUserRole() {
  const { data, isLoading } = useUser();

  const role = resolveUserRole(data?.profile);
  const team = data?.profile?.team?.trim() || null;
  const isAdmin = isAdminRole(role);
  // By role, not by having a team. Teams were cleared on 22.09.2026 (every
  // domain and every account is teamless until management defines them), and
  // this line was gating on the team, so the button vanished for managers even
  // though the "Managers insert domains" policy lets them through.
  const canAddDomain = isAdmin || role === "manager";

  return { role, team, isAdmin, canAddDomain, isLoading };
}
